import { useTheme } from '../theme/ThemeProvider';

export const EMPTY_TOKEN_SRC = {
  light: '/images/main/empty-token.png',
  dark: '/images/main/empty-token-light.svg',
};

export function getEmptyTokenSrc(isDark) {
  return isDark ? EMPTY_TOKEN_SRC.dark : EMPTY_TOKEN_SRC.light;
}

export default function EmptyTokenImg({ className, width, style, alt = '', src }) {
  const { isDark } = useTheme();
  const imageSrc = src || getEmptyTokenSrc(isDark);

  return (
    <img
      className={className}
      src={imageSrc}
      width={width}
      style={style}
      alt={alt}
    />
  );
}
